import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "providers-grid" }
const _hoisted_2 = { class: "pv-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoTile = _resolveComponent("LogoTile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providers, (p) => {
      return (_openBlock(), _createElementBlock("div", {
        key: p.name,
        class: _normalizeClass(["pv-tile", { 'pv-tile--self': !!p.icon }])
      }, [
        _createVNode(_component_LogoTile, {
          logo: p.logo,
          icon: p.icon,
          alt: p.name + ' logo',
          size: 46
        }, null, 8, ["logo", "icon", "alt"]),
        _createElementVNode("span", _hoisted_2, _toDisplayString(p.name), 1)
      ], 2))
    }), 128))
  ]))
}